import React from 'react'
import '../styles/Message.css'

const Message = ({firstName, lastName,area, message, display, handleClose}) => {
   
    return(

        <div style={{display: display}} className="modal" onClick = {handleClose}>
 
            <div className="modal-content">

                <h2  className="close">&times;</h2>

                <p className = "message-p"> Thank you for contacting us <b>{firstName} {lastName}</b>!</p>

                <p className = "message-p">We have recieved your message and are processing your request.</p>

                <p className = "message-p">One of our representatives will get back with you with quotes for <b>{area}</b> work.</p>

                <p className = "message-p"> We will review your message and get back shortly!</p>

            </div>

        </div>

    )

}

export default Message